export default __webpack_public_path__ + "static/adam-parry-11f9a663fd96cc806f9e8d3bdd3ddf20.png";